import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Antes me paralizaba… ahora actúo.',
  name: 'Sofía V.',
  role: 'Enfermera'
}, {
  quote: 'Mi cabeza está mucho más ordenada en guardia.',
  name: 'Daniela P.',
  role: 'Estudiante'
}, {
  quote: 'Es lo que necesitaba para sentirme segura de verdad.',
  name: 'Gabriel S.',
  role: 'Enfermero'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-282">
      <div className="max-w-xl mx-auto" data-id="element-283">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-284">
          🏥 Profesionales reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-285">
          Esto dicen quienes ya aplican el sistema en su aula
        </p>

        <div className="space-y-3" data-id="element-286">
          {comments.map((c, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-4 rounded-xl" data-id="element-287">
              <div className="flex gap-0.5 mb-2" data-id="element-288">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-289" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-2 leading-relaxed" data-id="element-290">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-291">
                <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-292">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-293">
                  <p className="font-bold text-white text-xs" data-id="element-294">{c.name}</p>
                  <p className="text-[11px] text-gray-500" data-id="element-295">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}